import React from "react";

interface CharacterCounterProps {
  currentCount: number;
  maxCount?: number;
  className?: string;
}

export const CharacterCounter: React.FC<CharacterCounterProps> = ({
  currentCount,
  maxCount,
  className = "",
}) => {
  const isNearLimit = maxCount ? currentCount >= maxCount * 0.8 : false;
  const isOverLimit = maxCount ? currentCount > maxCount : false;

  return (
    <div
      className={`text-xs font-mono ${
        isOverLimit
          ? "text-destructive font-semibold"
          : isNearLimit
          ? "text-amber-500"
          : "text-muted-foreground"
      } ${className}`}
    >
      {maxCount ? (
        <span>
          {currentCount}/{maxCount} characters{" "}
          {isOverLimit && "(limit exceeded)"}
        </span>
      ) : (
        <span>{currentCount} characters</span>
      )}
    </div>
  );
};
